export default {"src":"/_next/static/media/right_arrow_icon.cf512aea.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};